import { useState, useEffect } from "react";
import toast, { Toaster } from 'react-hot-toast';
import { GETSUMMARY, GETALLPRODUCTS, GETCATEGORIESLIST,AddReply,GetVendorReviews  } from "../../api/apiConfig";
import { apiGet, apiPost } from "../../utils/services";
import { Paper, Box, Table, TableBody, TableCell, TableHead, TableRow, Grid, Button, Stack, Divider, IconButton, Switch, TableContainer, Pagination, Badge, TextField, ImageList, ImageListItem } from "@mui/material";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Logo, Spinner } from "../../components/atoms";
import { useQuery } from "react-query";
import { getProductModels } from "../../api/api";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import { FaArrowRight, FaBackspace, FaCamera, FaFileImage, FaFilter, FaImages, FaInfoCircle, FaTimes, FaTimesCircle, FaVideo } from "react-icons/fa";
import Popup from "../../components/atoms/Popup/Popup";
import { BiCheckCircle, BiImage, BiSend, BiShare } from "react-icons/bi";
import { moneyFormat, stripText } from "../../components/atoms/Helper/helper";
import  AvatarBox  from "../../components/atoms/AvatarBox/AvatarBox";
import  RatingItem  from "../../components/atoms/RatingItem/RatingItem";
import { pieChart } from "../../components/atoms/Chart/pieChart";
import { useMediaQuery } from "react-responsive";
import { lineChart } from "../../components/atoms/Chart/lineChart";
import { barChart } from "../../components/atoms/Chart/barChart";
import {timeLineChart} from "../../components/atoms/Chart/timeLineChart";
import Progress from "../../components/atoms/Progress/progress";
import SwipeableViews from 'react-swipeable-views';
import Modal from "react-responsive-modal";
import { useForm } from "react-hook-form";
import { timelineClasses } from "@mui/lab";

const Summary = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm();
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' })
    
    const [productData, setProductData] = useState();
    const [allMerchant, setAllMerchant] = useState(false);
    const [summaryData, setSummaryData] = useState();
    const [reviews, setReviews] = useState([]);
    const [popup, setPopup] = useState({})
    const [state, setState] = useState({
        productCategories: [],
    });
    const isAdmin =localStorage.getItem("roleId")=="1"
    const [currentTime, setCurrentTime] = useState({id:0,name:'All Time'});
    const [addUnOrdered, setAddUnOrdered] = useState(false);
    const [page, setPage] = useState(1);

    const [pictureIndex, setPictureIndex] = useState(1);
    const [pictureIndex2, setPictureIndex2] = useState(1);
    const [pictureModal, setPictureModal] = useState([]);
    const [pictureModal2, setPictureModal2] = useState([]);
    const [videoModal, setVideoModal] = useState([]);
    const [commentModal, setCommentModal] = useState(null);
   
    const openPopup = (name, e,content="") => {
        setPopup({ ...popup, [name]: popup[name] ? null : e.currentTarget,content:content })
    }
    const closePopup = () => {
        setPopup({})
    }
    const updateState = (data) => setState((prevState) => ({ ...prevState, ...data }));

    const {
        productCategories,
        selectedCategory,
        selectedModel,
        startDate,
        endDate,
    } = state;
    const currentCategory = selectedCategory?.label
    ? selectedCategory
    : {value:0,label:'All Products'};

    useEffect(() => {
        getProducts();
        getProductCategories();
        getVendorReviews();
    }, []);

    useEffect(() => {
        getSummary(currentCategory,startDate,endDate);
    }, [startDate, endDate,selectedCategory,currentTime,allMerchant,addUnOrdered]);

    const getProducts = async () => {
        const res = await apiPost(GETALLPRODUCTS, { vendor: "The Cricket Store" });
        if (res) {
          setProductData(res);
        }
    };

    const getSummary = async ({ productCat=currentCategory,start=startDate,end=endDate}) => {
        setIsLoading(true);
        const res = await apiPost(GETSUMMARY, {
            ProductCategoryId: productCat?.value,
            ModelId: 0,
            addUnOrdered:addUnOrdered,
            allMerchant:allMerchant,
            startDate: start != null ? moment(start).format('DD/MM/yyyy'):'',
            endDate: end != null ? moment(end).format('DD/MM/yyyy'):'',
            filter:currentTime.id,
        });
        if (res) {
          setSummaryData(res);
        }
        setIsLoading(false);
    };

    const getProductCategories = async () => {
        const res = await apiGet(GETCATEGORIESLIST);
        if (res) {
            const { data } = res;
            updateState({ productCategories: data });
        }
    };

    const getVendorReviews = async () => {
        const res = await apiGet(GetVendorReviews);
        if (res) {
           console.log("Reviews",res)
           setReviews(res)
        }
    };


    const prodCategories =
        productCategories &&
        productCategories.map((m) => ({
            value: m.id,
            label: m.name,
        }));


    const setSelectedProductModel = (option) => {
        updateState({ selectedModel: option });
    };
    const convertTimeFormat = (dateTime) => {
        const dateTimeOffsetValue = new Date(dateTime);


        const localDateTime = new Date(dateTimeOffsetValue.getTime() - (dateTimeOffsetValue.getTimezoneOffset() * 60000));

        // Get date part in the desired format (e.g., ddd MMM dd yyyy)
        const formattedDate = localDateTime.toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: '2-digit',
        year: 'numeric'
        });

        // Get time part in AM/PM format
        let hours = localDateTime.getHours();
        const minutes = localDateTime.getMinutes();
        const amOrPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert hours to 12-hour format

        // Format the time part with AM/PM
        const formattedTime = `${hours}:${minutes < 10 ? '0' : ''}${minutes} ${amOrPm}`;

        // Combine date and time parts
        return `${formattedDate} ${formattedTime}`;

    }
 

    const {
        isLoading: isProductModelsLoading,
        data: { data: productModels } = { data: [] },
    } = useQuery(
        ["models", selectedCategory?.value],
        () => getProductModels(currentCategory.value),
        {
            enabled: currentCategory != null,
        }
    );

    const setSelectedCategory = (option) => {
        updateState({ selectedCategory: option, selectedModel: null, selectedGrade: null });
       // const { value } = option;
     
    };
   



    const heading = [
        { id: 1, name: 'Orders' },
        { id: 2, name: 'Revenue' },
        { id: 3, name: 'AVG Basket' },
    ]

    const [value, setValue] = useState(1);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if(newValue==3 && !addUnOrdered) setAddUnOrdered(true)  
        if(newValue!=3 && addUnOrdered) setAddUnOrdered(false)  
    };

    function pageSwitcher() {
        switch (page) {
            case 1: return page1();
            case 2: return page2();
            case 3: return page3();
            case 4: return page4();
            case 5: return page5();
            case 6: return page6();
            case 7: return page7();
            case 8: return page8();
        }

    }

    return (
     
            pageSwitcher()
           
    )

    

    function page1() {
        return (
            <div className="tabPanelCls h-100" >
                <Toaster />

                <div className="dispatchTimer" style={{ position: 'relative' }}>
                    <div style={{ width: '100%', background: 'white', }}>
                        <div className=" fixed" >
                            <h2 className="ruby center" style={{ paddingTop: "5px" }}>
                            Summary
                            </h2>
                        </div>
                    </div>

                    <Box style={{ marginTop: '35px' }} sx={{ width: '100%', typography: 'body1' }}>

                    <Tabs defaultIndex={0}>
          <div className="fixed" style={{width:'100%'}}>

          <TabList style={{width:'100%'}} >
            {heading.map(d => {
                    return (
                        <Tab onClick={(e)=>handleChange(e,d.id)} key={d.id}>
                            {d.name}
                        </Tab>
                    )
                })}
            {isTabletOrMobile &&
                <div className="red center space-left2  xs"  onClick={(e) => {openPopup('more', e);}}>
                    Other Metrics
                </div>
            }
          </TabList>
          <hr  style={{ borderBottom: "solid 2px #E3031F", marginTop:'-5px'}}/>
          </div>
          <div style={{paddingTop:isTabletOrMobile?'50px':'80px'}}>
            
          <TabPanel  key={1}  style={{ paddingTop: "0px",width:!isTabletOrMobile &&'95%',paddingLeft:'2px' }}>
                {getOrders()}
          </TabPanel>
          <TabPanel value={2}  style={{ paddingTop: "0px", width:!isTabletOrMobile &&'95%',paddingLeft:'2px' }}>
            {getRevenue()}
        </TabPanel>
        <TabPanel value={3}  style={{ paddingTop: "0px",width:!isTabletOrMobile &&'95%',paddingLeft:'2px' }}>
            {getAVGBasket()}
        </TabPanel>
        
        </div>
        </Tabs>


                    </Box>
                    {!isTabletOrMobile &&  getMetrics()}
                </div>
            </div>
        )
    }

    function box(title,value,css='red'){
        return (
            <div className={!isTabletOrMobile &&"space-top"} style={{background:"#F0F0F0 0% 0% no-repeat padding-box",borderRadius:'24px'}}>
                <div className="bold sm center padding" style={{background:"#D8D8D8 0% 0% no-repeat padding-box",borderRadius:'23px 23px 0px 0px ',fontSize:'12px'}}>{title}</div>
                <h3 className={"padding2 center "+css}>{value}</h3>
            </div>
        )
    }
    function bigBox(title,value, css='red', width='150px'){
        return (
            <div className={!isTabletOrMobile &&"space-top"} style={{background:"#F0F0F0 0% 0% no-repeat padding-box",borderRadius:'24px', width:width}}>
                <div className="bold sm center padding" style={{background:"#D8D8D8 0% 0% no-repeat padding-box",borderRadius:'23px 23px 0px 0px ',fontSize:'12px'}}>{title}</div>
                <h3 className={"padding2 center "+css}>{value}</h3>
                
            </div>
        )
    }
    function page2() {
        const data=summaryData?.data?.acceptanceTime;
        const acceptanceTimeList = summaryData?.data?.acceptanceTimes;
       
        const timeList = (Array.isArray(acceptanceTimeList) ? acceptanceTimeList : []).map(timeSpan => {
            const [hours, minutes, seconds] = timeSpan.acceptanceTime.split(':').map(parseFloat);
            
            return hours * 60 + minutes + seconds / 60;
        });

        let t=0;
        let minAcceptanceTime = Math.min(...timeList);
        let maxAcceptanceTime = Math.max(...timeList);
        let minValueIndex = timeList.indexOf(minAcceptanceTime);
        let maxValueIndex = timeList.indexOf(maxAcceptanceTime);
        console.log("min accptance", minAcceptanceTime);
        let minAccptTimeRange = acceptanceTimeList[minValueIndex];
        let maxAccptTimeRange = acceptanceTimeList[maxValueIndex];
        console.log("index", minValueIndex, maxValueIndex, minAcceptanceTime, maxAcceptanceTime);
        console.log("lets see what we have", minAccptTimeRange, maxAccptTimeRange, acceptanceTimeList, timeList);
       let minTime = minAcceptanceTime === Infinity ? 0 : minAcceptanceTime;
       let maxTime = maxAcceptanceTime === -Infinity ? 0 : maxAcceptanceTime;
       console.log("min max", minTime, maxTime);
        if (data?.length>0) {
            t= data.reduce((a, b) => {
              a += b.value;
              return a;
            }, 0);
          }
        t=Math.round(t * 10) / 10
        let info='The time between a customer placing an order and the order being accepted in the Order Manager'
        const d3= [
            {
              name: "Acceptance time",
              type: 'column',
              data: getChartDataByMonth(data),
              x: getMonthofYear()
            },
            // {
            //     name: "Goal",
            //     data: [t,t,t,t,t,t,t]
            // }
          ]

       
      
        return (
            <div className="tabPanelCls h-100" >
                <div className="dispatchTimer" style={{ position: 'relative' }}>
                    <div className="fixed">
                        <div style={{ paddingTop: "5px" }}>
                         <h2 className="ruby center"><IconButton onClick={()=>setPage(1)}><FaBackspace/></IconButton>Acceptance Time<FaInfoCircle size="20px"color="red" className="click space-left2" onClick={(e) => openPopup('info', e,info)} /></h2>
                      
                        </div>
                    </div>
                    <div style={{marginTop:isTabletOrMobile?"50px":"80px"}}>
                        <div style={{width:'100%'}}>
                        {filter("Acceptance time overview for ",'Filter2')}
                        </div>
                        {/* <div>Acceptance Time</div> */}
                        <Grid container spacing={4} rowSpacing={1}>
                            <Grid item md={10} xs={12}>
                                {barChart(d3,'Time (mins)',2,isTabletOrMobile?230:400)}
                            </Grid>
                            <Grid item md={2} xs={12} sx={{ width: '100%' }} className="center2 space-bottom">
                                <Stack direction={isTabletOrMobile?"row":"column"} spacing={2}>
                                    {bigBox("AVG Acceptance Time",countdown(t),t>5?'red':'green')}
                                    {bigBox("Goal Acceptance Time","5 mins",'')}
                                </Stack>
                            </Grid>
                        </Grid>
                       
                    </div>
                    <div>
                    <Grid item md={2} xs={12} className="center2 space-bottom">
                                <Stack direction={isTabletOrMobile?"row":"row"} spacing={2}>
                                    <div style={{width:isTabletOrMobile?'150px':  '350px', textAlign:'center'}}>
                                    {/* {bigBox("Fastest Acceptance Time",minTime < 1? "0mins" : countdown(minTime), minTime>5?'red':'green', isTabletOrMobile?'150px':  '350px')} */}
                                    
                                    <Paper className="padding">
                                        <div className="bold ruby center sm" style={{textAlign:'center'}}>Fastest Acceptance Time </div>
                                        <h3 className="center2 red">{minTime < 1? "0mins" : countdown(minTime)}</h3>
                                        <div className="center grey xs">Acceptance Time</div>
                                    </Paper>
                                
                           
                                    </div>
                                    <div style={{width:isTabletOrMobile?'150px':  '350px', textAlign:'center'}} >
                                    {/* {bigBox("Slowest Acceptance Time",maxTime < 1? "0mins" : countdown(maxTime), maxTime>5?'red':'green', isTabletOrMobile?'150px':  '350px')} */}
                                    <Paper className="padding">
                                        <div className="bold ruby center sm" style={{textAlign:'center'}}>Slowest Acceptance Time</div>
                                        <h3 className="center2 red">{maxTime < 1? "0mins" : countdown(maxTime)}</h3>
                                        <div className="center grey xs">Acceptance Time</div>
                                    </Paper>
                                    </div>                                  
                                    
                                </Stack>
                    </Grid>
                    </div>
                </div>

                
            </div>
        )
    }

    function page3() {
        const data=summaryData?.data?.lostRevenue
        let t=0
        if (data?.length>0) {
            t= data.reduce((a, b) => {
              a += b.value;
              return a;
            }, 0);
          }
        t=Math.round(t * 10) / 10
        let info='The Total value of items that customers ordered but were declined in the Order Manager'
        const d3= [
            {
              name: "Total Declined",
              type: 'column',
              data: getChartDataByMonth(data),
              x: getMonthofYear()
            },
            // {
                
            //     name: "Goal",
            //     data: [t,t,t,t,t,t,t]
            // }
          ]

       
        return (
            <div className="tabPanelCls h-100" >
                <div className="dispatchTimer" style={{ position: 'relative' }}>
                    <div className="fixed">
                        <div style={{ paddingTop: "5px" }}>
                        <h2 className="ruby center"><IconButton onClick={()=>setPage(1)}><FaBackspace/></IconButton>Lost Revenue<FaInfoCircle size="20px"color="red" className="click space-left2" onClick={(e) => openPopup('info', e,info)} /></h2>
                        
                        </div>
                    </div>
                    <div style={{marginTop:isTabletOrMobile?"50px":"80px"}}>
                        <div style={{width:'100%'}}>
                        {filter("Lost Revenue overview for ",'Filter2')}
                        </div>
                        {/* <div>Lost Revenue</div> */}
                        <Grid container spacing={4} rowSpacing={1}>
                            <Grid item md={10} xs={12}>
                             {barChart(d3,"Lost Revenue (£)",1,isTabletOrMobile?230:400)}
                                {/* {lineChart(d3,"Amount (£)","smooth",2)} */}
                            </Grid>
                            <Grid item md={2} xs={12} className="center2 space-bottom">
                                <Stack direction={isTabletOrMobile?"row":"column"} spacing={2} >
                                    {box("Total Lost Revenue",moneyFormat(t),t>0?'red':'green')}
                                    {box("Lost Revenue Goal",moneyFormat(0),'')}
                                </Stack>
                            </Grid>
                        </Grid>
                       
                    </div>
                </div>

                
            </div>
        )
    }

    function page4() {
        const data=summaryData?.data?.dispatchTime
        let t=0
        if (data?.length>0) {
            t= data.reduce((a, b) => {
              a += b.value;
              return a;
            }, 0);
          }
        t=Math.round(t * 10) / 10
        let info='The average duration between accepting an order and dispatching it'
        const d3= [
            {
              name: "Total Dispatched",
             
              data: getChartDataByMonth(data),
              x: getMonthofYear()
            },
            // {
            //     name: "Goal",
            //     data: [6,8,8,7,5,7,4]
            // }
          ]
          
        return (
            <div className="tabPanelCls h-100" >
                <div className="dispatchTimer" style={{ position: 'relative' }}>
                    <div className="fixed">
                        <div style={{ paddingTop: "5px" }}>
                        <h2 className="ruby center"><IconButton onClick={()=>setPage(1)}><FaBackspace/></IconButton>AVG Dispatch Time<FaInfoCircle size="20px"color="red" className="click space-left2" onClick={(e) => openPopup('info', e,info)} /></h2>
                      
                        </div>
                    </div>
                    <div style={{marginTop:isTabletOrMobile?"50px":"80px"}}>
                        <div style={{width:'100%'}}>
                        {filter("AVG Dispatch Time overview for ")}
                        </div>
                        {/* <div>AVG dispatch Time</div> */}
                        <Grid container spacing={4} rowSpacing={1}>
                            <Grid item md={10} xs={12}>
                            {timeLineChart(d3,"Time","straight")}
                                {/* {lineChart(d3,"Time (mins)","smooth",2)} */}
                            </Grid>
                            <Grid item md={2} xs={12} className="center2 space-bottom">
                             <Stack direction={isTabletOrMobile?"row":"column"} spacing={2}>
                                {box("AVG Dispatch Time",countdown(t),t>5?'red':'green')}
                                {box("Goal Dispatch Time","5 mins",'')}
                             </Stack>
                            </Grid>
                        </Grid>
                       
                    </div>
                </div>

                
            </div>
        )
    }

    function page8() {
        const data=summaryData?.data?.deliveryTime
        let t=0
        if (data?.length>0) {
            t= data.reduce((a, b) => {
              a += b.value;
              return a;
            }, 0);
          }
        t=Math.round(t * 10) / 10
        let info='The average duration between delivering an order to the customer'
        const d3= [
            {
              name: "Total Delivery",
              
              data: getChartDataByMonth(data),
              x: getMonthofYear()
            },
            // {
            //     name: "Goal",
            //     data: [6,8,8,7,5,7,4]
            // }
          ]
        return (
            <div className="tabPanelCls h-100" >
                <div className="dispatchTimer" style={{ position: 'relative' }}>
                    <div className="fixed">
                        <div style={{ paddingTop: "5px" }}>
                        <h2 className="ruby center"><IconButton onClick={()=>setPage(1)}><FaBackspace/></IconButton>AVG Delivery Time<FaInfoCircle size="20px"color="red" className="click space-left2" onClick={(e) => openPopup('info', e,info)} /></h2>
                      
                        </div>
                    </div>
                    <div style={{marginTop:isTabletOrMobile?"50px":"80px"}}>
                        <div style={{width:'100%'}}>
                        {filter("AVG Delivery Time overview for ")}
                        </div>
                        {/* <div>AVG dispatch Time</div> */}
                        <Grid container spacing={4} rowSpacing={1}>
                            <Grid item md={10} xs={12}>
                            {timeLineChart(d3,'Time','straight')}
                                {/* {lineChart(d3,"Time (mins)","smooth",2)} */}
                            </Grid>
                            <Grid item md={2} xs={12} className="center2 space-bottom">
                             <Stack direction={isTabletOrMobile?"row":"column"} spacing={2}>
                                {box("AVG Delivery Time",countdown(t),t>5?'red':'green')}
                                {box("Goal Delivery Time","5 mins",'')}
                             </Stack>
                            </Grid>
                        </Grid>
                       
                    </div>
                </div>

                
            </div>
        )
    }
   

    function page5() {
        const data=summaryData?.data?.topSelling
        const d3= [
            {
                name: "This Year Performance",
                data:  getChartDataByProductCat(data?.v1),
                x: productCategories.filter(d=>
                    data?.v1?.filter(x=>x.productCat==d.name)[0]?.value>0
                ).map((m) => ( m.name))
              }
          ]
        
          const getQuantity = (variants = []) => {
            if (variants.length) {
              return variants.reduce((acc, variant) => {
                acc += variant.inventoryQuantity;
          
                return acc;
              }, 0);
            }
          
            return;
          };
          
          const getLowestAmount = (variants) => {
            return variants!=null && variants?.reduce((min, current) =>
              current.price < min.price ? current : min
            );
          };


          const VideoLayout = (props) => {
            const { className, overlayClass, src, onClick, idx } = props;
            return (
              <div className={className}>
                <div className={overlayClass} />
                <video controls style={{width:'800px'}}  className="">
                  <source src={src} type="video/mp4"></source>
                </video>
              </div>
            );
          };
        function getdescription(d){
            return <span dangerouslySetInnerHTML={{ __html: d }}>
            </span>;
        }
         
        function box(title,value){
            let count=0;
            return (
                <div className={!isTabletOrMobile &&"space-top"} style={{background:"#F0F0F0 0% 0% no-repeat padding-box",borderRadius:!isTabletOrMobile?'23px':'23px 23px 0px 0px ',minHeight:!isTabletOrMobile &&'100px'}}>
                    <div className="bold sm center padding" style={{background:"#D8D8D8 0% 0% no-repeat padding-box",borderRadius:'23px 23px 0px 0px ',fontSize:'12px'}}>{title}</div>
                   
                    <Grid container={!isTabletOrMobile} rowSpacing={2} spacing={2} className="padding2" style={{overflowX:'auto',display:isTabletOrMobile&&'flex'}}>
                        {data?.v2?.sort((a, b) => (b.count - a.count))?.map((dd,i)=>{

                            if(productData === undefined) 
                            {
                                return;
                            }
                             const d=productData.filter(x=>x.productId==dd.id)[0]
                              //const quantity = getQuantity(d?.variants);
                              const quantity = dd.count;
                              const lowestAmount = getLowestAmount(d?.variants);
                              if(d!=null) {
                                count++;
                              }
                              function view(d){
                                return (
                                    <Paper style={{background:'#F0F0F0',padding:'5px 10px'}}>
                                    <div className="center">
                                        <div className="bold" style={{fontSize:'12px'}}>{stripText(d?.title,20)}</div>
                                        <div style={{background:'#E3031F',padding:"5px 10px", borderRadius:'5px',color:'white',width:'fit-content',zIndex:10,display:'block',fontSize:'8px',position:'relative'}}>#{i+1}</div>
                                        <div style={{marginTop:'-20px'}}>
                                        {d?.images.length>0 ? (
                                                <div className="imageContainer">
                                                <img src={d?.images[0].src} className="productImgCls" />
                                                </div>
                                            ) : (
                                                <div className="emptyImage center2" style={{margin:'auto'}}>
                                                <FaCamera className={"menuIconCls"} color={"white"} size={20} />
                                                </div>
                                            )}
                                        </div>
                                        {/* <div className="truncate" style={{overflowY:'hidden',fontSize:'8px'}}>{getdescription(d?.description)}</div> */}
                                        <div className="push-left-right">
                                            <div className="sm">{quantity}<span className="xxs green">sold</span></div>
                                            <div className="sm">{moneyFormat(lowestAmount.price)}</div>
                                        </div>

                                    </div>
                                    </Paper>
                                )
                              }
                            return (
                            
                            d!=null &&count<=5 && (isTabletOrMobile?
                                <span style={{padding:'2px 10px'}} className="ruby">
                                      {view(d)}
                                </span>
                                :
                             <Grid item md={4} xs={6} className="center">
                                  {view(d)}
                             </Grid>
                             )
                            )
                        })}
                        
                    </Grid>
                </div>
            )
        }

        function PictureModal() {

            const styles = {
                root: {
                  position: 'relative',
                  maxWidth:isTabletOrMobile&&'300px'
                },
                slide: {
                  padding: 15,
                  minHeight: 100,
                  color: '#fff',
                
                },
                id1: {
                  backgroundColor: '#FEA900',
                },
                id2: {
                  backgroundColor: '#B3DC4A',
                },
                id3: {
                  backgroundColor: '#6AC0FF',
                },
              };
              const handlePage = (page) => setPictureIndex(page-1);
           
            return (
                <Modal style={{ width: '100%', overflowX: 'auto', overflowY: 'auto'}}
                open={pictureModal?.length>0} showCloseIcon={true} center onClose={()=>setPictureModal([])}>
                    
                        <div style={styles.root}>
                        <SwipeableViews  index={pictureIndex} onChangeIndex={(e)=>setPictureIndex(e)}
                            enableMouseEvents

                            >
                            {pictureModal.map((d, index) => {
                                
                                return (
                                <div style={{  cursor: "grab",}}>
                                    {/* <div style={{position:'absolute',bottom:'20vh'}} className='padding2'>
                                    <div className=".text-white .text-[80px] .font-semibold">Hand-Made</div>
                                    <div className=".text-green-900 .text-[100px] .font-bold">Products</div>
                                    </div> */}
                                     <div className="imageContainer center" >
                                         <img src={d.src} className="" style={{maxHeight:'400px',maxWidth:isTabletOrMobile?'250px':'400px'}} />
                                    </div>
                                    <span className='.text-lg .font-bold red'>{d?.title}</span>
                                    <span className='.text-sm'>{d?.message}</span>
                                </div>
                                )})}
                            </SwipeableViews>
                            {pictureModal.length>1 &&<Pagination  count={pictureModal.length}
                                    onChange={(event, value) => handlePage(value)}
                                    page={pictureIndex+1}  index={pictureIndex}/>}
                        </div>
    
                </Modal>
            )
        }

        function VideoModal() {

            const styles = {
                root: {
                  position: 'relative',
                },
                slide: {
                  padding: 15,
                  minHeight: 100,
                  color: '#fff',
                
                },
                id1: {
                  backgroundColor: '#FEA900',
                },
                id2: {
                  backgroundColor: '#B3DC4A',
                },
                id3: {
                  backgroundColor: '#6AC0FF',
                },
              };
            
            return (
                <Modal style={{ width: '100%', overflowX: 'auto', overflowY: 'auto'}}
                open={videoModal?.length>0} showCloseIcon={true} center onClose={()=>setVideoModal([])}>
                    
                        <div style={styles.root} className='padding'>
                        {videoModal.filter((v) => !v.isDeleted).slice(0,1)
                            .map((video) => {
                                return (
                                    <VideoLayout
                                        key={video.id || video.tempId}
                                        idx={video.id || video.tempId}
                                        className={"firstIndexImages2"}
                                        overlayClass={"overlayFirstInddex2"}
                                        src={video.id ? video.value : video.src}
                                    
                                    ></VideoLayout>
                                )
                                
                            })}
                       
                        </div>
    
                </Modal>
            )
        }
        
        function getDispatchTime(tag){
            return productCategories.filter(x=>tag.includes(x.name))[0]?.dispatchDays
          }
        
        function getTopSellingVariant(d){
          
            var variant=data?.v2?.filter(x=>x.id==d.productId)[0]?.variant;
          //  if(variant==null) return  d.variants[0].title
            if(variant==null) return  'NA'
            return variant
        }

        let info='This is the content about Top selling items'
        const itemList=productData?.filter(x=>selectedCategory?.label==null ?true: x.tag.includes(selectedCategory?.label))
        return (
            <div className="tabPanelCls h-100" >
                <div className="dispatchTimer" style={{ position: 'relative' }}>
                    <div className="fixed">
                        <div style={{ paddingTop: "5px" }}>
                            <h2 className="ruby center"><IconButton onClick={()=>setPage(1)}><FaBackspace/></IconButton>Top Selling Items<FaInfoCircle size="20px"color="red" className="click space-left2" onClick={(e) => openPopup('info', e,info)} /></h2>
                           
                        </div>
                    </div>
                    <div style={{marginTop:isTabletOrMobile?"50px":"80px"}}>
                    {filter("Top selling item for ")}
                    {PictureModal()}
                    {VideoModal()}
                        <Grid container spacing={2} rowSpacing={1}>
                            <Grid item md={7} xs={12}>
                                {barChart(d3,'Product Count',2,isTabletOrMobile?230:400)}
                            </Grid>
                            <Grid item md={5} xs={12}>
                                {box("Top 5 Selling Items",1,isTabletOrMobile?230:400)}
                            </Grid>
                        </Grid>

                    <h3 className="space-top">Product Optimization ({itemList?.length+" Items"})</h3>
                    <Paper className=" space-top2">
                        <TableContainer sx={{ overflowX: "auto", maxHeight: 440,
                            "&::-webkit-scrollbar": {
                                width: 5,
                                height: 5
                                },
                                "&::-webkit-scrollbar-track": {
                                backgroundColor: "white"
                                },
                                "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "red",
                                borderRadius: 3,
                                
                                },
                            }}>
                        <Table stickyHeader aria-label="sticky table" style={{tableLayout:isTabletOrMobile?'inherit':'fixed'}} >
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{width:'20%'}}><span className='bold'>Name</span></TableCell>
                                    <TableCell style={{width:'20%'}}><span className='bold'>Description</span></TableCell>
                                    <TableCell style={{width:'10%'}}><span className='bold'>Photos</span></TableCell>
                                    <TableCell style={{width:'10%'}}><span className='bold'>Videos</span></TableCell>
                                    <TableCell style={{width:'10%'}}><span className='bold center2'>Exclusive</span></TableCell>
                                    <TableCell style={{width:'10%'}}><span className='bold center2'>Top Deal</span></TableCell>
                                    <TableCell style={{width:'10%'}}><span className='bold'>Dispatch Time</span></TableCell>
                                    <TableCell style={{width:'10%'}}><span className='bold'>Top Selling Variant</span></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody style={{maxHeight:'200px',overflowY:'auto'}}>
                                {itemList?.map((data,i) => {
                                    return (
                                        <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell><span>{stripText(data.title,isTabletOrMobile?20:40)}</span></TableCell>
                                            <TableCell><span className={!isTabletOrMobile ?"truncate":"truncate2"}>{getdescription(data?.description)}</span></TableCell>
                                            <TableCell>
                                            {data.images.length>0 ? (
                                                <Badge badgeContent={"+"+data.images.length-1} color="secondary">
                                                    <div className="imageContainer click" onClick={()=>{setPictureIndex(0);setPictureModal(data.images)}}>
                                                    <img src={data.images[0].src} className="productImgCls" />
                                                    </div>
                                                </Badge>
                                            ) : (
                                                <div className="emptyImage center2" style={{margin:'auto'}}>
                                                <FaCamera className={"menuIconCls"} color={"white"} size={20} />
                                                </div>
                                            )}
                                            </TableCell>
                                            <TableCell>
                                            {data.videos.length>0 ? (data.videos
                                                .filter((v) => !v.isDeleted).slice(0,1)
                                                .map((video) => {
                                                    return (
                                                    <div className="click" onClick={()=>setVideoModal(data.videos)}>
                                                     <div className="emptyImage center2" style={{margin:'auto'}}>
                                                       <FaVideo className={"menuIconCls"} color={"white"} size={20} />
                                                       </div>
                                                    </div>
                                                    )
                                                    
                                                }))
                                                : (
                                                    <div style={{margin:'auto'}}>
                                                    {/* <FaCamera className={"menuIconCls"} color={"white"} size={20} /> */}
                                                    </div>
                                                )}
                                            </TableCell>
                                            <TableCell><span className="center2" style={{margin:'auto'}}>{data.isExclusive?<BiCheckCircle size={"24px"} color="green"/>:<FaTimesCircle size={"24px"} color="red"/>}</span></TableCell>
                                            <TableCell><span className="center2" style={{margin:'auto'}}>{data.tag.includes("Top Deal")?<BiCheckCircle size={"24px"} color="green"/>:<FaTimesCircle size={"24px"} color="red"/>}</span></TableCell>
                                            <TableCell><span className="center2" style={{margin:'auto'}}>{getDispatchTime(data.tag)+" days"}</span></TableCell>
                                            <TableCell><span className={!isTabletOrMobile ?"truncatex":"truncate2x"}>{stripText(getTopSellingVariant(data),20)}</span></TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                        </TableContainer>
                    </Paper>
                    </div>
                </div>
               
                      
            </div>
        )
    }

    function page6() {
        let data=reviews


        function CommentModal() {
            const onSubmit = async (data) =>{
                setIsLoading(true);
                const object={
                    ReviewId:commentModal.reviewId,
                    Content:data.message,
                }
                
                const res = await apiPost(AddReply, object);
                if (res) {
                    toast.success("Successful");
                    getVendorReviews();
                    setCommentModal(null)
                } else {
                    toast.error("Failed");
                }
                setIsLoading(false);
            }
            return (
                <Modal style={{ width: '100%', overflowX: 'auto', overflowY: 'auto'}}
                open={commentModal!=null} showCloseIcon={true} center onClose={()=>setCommentModal(null)}>
                    
                        <div className='padding'>

                        <Stack direction={"row"} spacing={2}>

                        <AvatarBox name={commentModal?.reviewerName} image={commentModal?.pics} showname={false}  className={"white lg"} />
                        <div>
                            <div className="sm">{commentModal?.reviewerName}</div>
                            <RatingItem value={commentModal?.rating}/>
                        </div>
                        </Stack>

                            <div className="sm bold">{commentModal?.title}</div>
                            <div className="sm ">{commentModal?.body}</div>
                       
                        <form onSubmit={handleSubmit(onSubmit)} className="space-top">
                            <Grid container spacing={2}>
                                <Grid item md={12} xs={12}>
                                    <TextField
                                    fullwidth sx={{width:'100%',background:'#fff'}}  size="small" {...register("message",{ required: true})} placeholder='Enter your response' multiline maxRows={4} rows={5} style={{width:'100%'}} />
                                    {errors.message &&  <p className="error">Your response is required</p>}
                                </Grid>
                            </Grid>
                            <div className='push-right'>
                            <Button  type="submit"
                            startIcon={ isLoading? <Spinner
                                size={20}
                                color="red"
                                loading={isLoading}
                                // style={{ marginTop: marginTop }}
                            />:<BiSend sx={{color:'white'}}/>} 
                             className='space-top space-bottom push-right' variant='contained' >Send Response</Button>
                            </div>
                        </form>

                        </div>
                </Modal>
            )
        }

        function PictureModal2() {

            const styles = {
                root: {
                  position: 'relative',
                },
                slide: {
                  padding: 15,
                  minHeight: 100,
                  color: '#fff',
                
                },
                id1: {
                  backgroundColor: '#FEA900',
                },
                id2: {
                  backgroundColor: '#B3DC4A',
                },
                id3: {
                  backgroundColor: '#6AC0FF',
                },
              };
              const handlePage = (page) => setPictureIndex2(page-1);
           
            return (
                <Modal style={{ width: '100%'}}
                open={pictureModal2?.length>0} showCloseIcon={true} center onClose={()=>setPictureModal2([])}>
                    
                        <div  className='padding'>
                        <ImageList sx={{ width:"100%",maxHeight:'300vh',overflowY:'auto'}} cols={isTabletOrMobile?1:1} variant="quilted" gap={20}>
                            {pictureModal2.map((item) =>{
                               
                            return (
                            <ImageListItem key={item} style={{background:'none'}}>
                            <img
                                style={{maxHeight:'400px',maxWidth:isTabletOrMobile?'250px':'400px'}}
                                src={`${item}?h=448&fit=crop&auto=format`}
                                srcSet={`${item}?h=448&fit=crop&auto=format&dpr=2 2x`}
                                alt={item}
                                loading="lazy"
                            />
                            </ImageListItem>
                        )})}
                        </ImageList>

                       
                        </div>
    
                </Modal>
            )
        }

        const dd=[
            {id:1,name:"James Balnt",rating:5,comment:"Order was delivered fast and packaged well so that content didn't break apart",date:"12/12/2023",pics:"",hasresponded:true},
            {id:1,name:"James DKI",rating:3,comment:"Order was delivered fast and packaged well so that content didn't break apart",date:"12/12/2023",pics:"",hasresponded:false},
            {id:1,name:"James Sdj",rating:4,comment:"Order was delivered fast and packaged well so that content didn't break apart",date:"12/12/2023",pics:"",hasresponded:true},
            {id:1,name:"Moses KI",rating:5,comment:"Order was delivered fast and packaged well so that content didn't break apart",date:"12/12/2023",pics:"",hasresponded:false},
            {id:1,name:"HD CX",rating:2,comment:"Order was delivered fast and packaged well so that content didn't break apart",date:"12/12/2023",pics:"",hasresponded:false},
            {id:1,name:"KDD YU",rating:1,comment:"Order was delivered fast and packaged well so that content didn't break apart",date:"12/12/2023",pics:"",hasresponded:false},
            {id:1,name:"JKDDK HD",rating:3,comment:"Order was delivered fast and packaged well so that content didn't break apart",date:"12/12/2023",pics:"",hasresponded:false},
            {id:1,name:"NX XX",rating:5,comment:"Order was delivered fast and packaged well so that content didn't break apart",date:"12/12/2023",pics:"",hasresponded:false},
        ]

        let info='View all feedback shared by your customers after they receive their order'
        let avgRating=data?.length>0 ? (data?.reduce((a,v) =>  a = a + v.rating , 0 )/data?.length):0
        return (
            <div className="tabPanelCls h-100" >
                <div className="dispatchTimer" style={{ position: 'relative' }}>
                    <div className="fixed">
                        <div style={{ paddingTop: "5px" }}>
                             <h2 className="ruby center"><IconButton onClick={()=>setPage(1)}><FaBackspace/></IconButton>{isTabletOrMobile?"Customer Feedback":"WHAT YOUR CUSTOMERS SAY"}<FaInfoCircle key={134} size="20px"color="red" className="click space-left2" onClick={(e) => openPopup('info', e,info)} /></h2>
                           
                        </div>
                    </div>
                    {CommentModal()}
                    {PictureModal2()}
                    <div style={{marginTop:isTabletOrMobile?"50px":"80px"}}>
                        <div style={{ background:'#EFEFEF',borderRadius:'3px',width:'92%',marginRight:'15px'}} className="padding fixed">
                            <div className="ruby center">
                                <span className="bold lg">The Cricket Store </span>
                                <span className="space-left2 lg">Rating</span>
                            </div>
                            <Stack direction={"row"} spacing={1} className="center">
                                <span className="bold">{avgRating}</span>
                                <span><RatingItem value={avgRating}/></span>
                                <span className="xs">{data?.length} reviews</span>
                            </Stack>
                        </div>
                        <Grid container spacing={isTabletOrMobile?1:4}  style={{paddingTop:'100px'}}>
                        {data?.map(f=>{
                            return (
                            <Grid item md={4} xs={12}>
                                <Paper className="padding">
                                    <Stack direction={"row"} spacing={1}  justifyContent="space-between">
                                    <Stack direction={"row"} spacing={1} className="center2">
                                        <AvatarBox name={f.reviewerName} image={f.pics} showname={false}  className={"white lg"} />
                                        <div>
                                            <div className="sm truncate">{f.reviewerName}</div>
                                            <RatingItem value={f.rating}/>
                                        </div>
                                    </Stack>
                                       <div>
                                       <div className="xxs truncate"> {moment(f.updatedAt).fromNow()}</div>
                                       <div className="push-right" style={{marginTop:'-1px'}}>
                                        {f.reviewPictureUrls==""? 
                                            <IconButton disabled size="small" className="xs italic light push-right"><BiImage/></IconButton>
                                            :
                                            <IconButton size="" className=" italic green click push-right" onClick={()=>setPictureModal2(f.reviewPictureUrls.split(','))}><BiImage/></IconButton>
                                        }
                                        </div>
                                       </div>
                                    </Stack>
                                    <div>
                                        <div className="xs bold">{f.title}</div>
                                        <div className="xs">{f.body}</div>
                                    </div>
                                    <Grid container justifyContent="space-between" className="center2">
                                        <Grid item md="auto">
                                        <div className="ruby center2">
                                            <Logo className="header-logo sm-logo"/>
                                            <div className={isTabletOrMobile &&"space-left2"}>
                                                <div className="xxs">Provided On</div>
                                                <div className="xxs red bold">The Cricket Store</div>
                                            </div>
                                        </div>
                                        </Grid>
                                        <Grid item md="auto">
                                        <Stack direction={"row"} spacing={1}>
                                            {/* <Button  size="small" variant="contained" startIcon={<BiShare/>}>
                                               <span className="xxs">Share</span>
                                            </Button> */}
                                            <Button onClick={()=>setCommentModal(f)} size="small" variant="contained" disabled={f.responded}>
                                                <span className="xxs">{f.responded?"Responded":"Respond"}</span>
                                            </Button>
                                        </Stack>
                                        </Grid>
                                    </Grid>
                                </Paper>
                               
                            </Grid>
                            )
                        })}
                        </Grid>

                    </div>
                </div>
            </div>
        )
    }

    function page7() {

        const data=summaryData?.data?.customerMetric
       

        const d1=[
            {id:1,title:"New Customers",value:data?.v1.reduce((a,v) =>  a = a + v.value , 0 ),info:'Customers who are making their first purchase from your band on The Cricket Store'},
            {id:2,title:"Returning Customers",value:data?.v2.reduce((a,v) =>  a = a + v.value , 0 ),info:'Customers that have previously made a purchase from your band on The Cricket Store'},
       ]
        const d2=[
            {id:1,title:"Standard Price Customers",value:data?.v3.standardCustomers.reduce((a,v) =>  a = a + v.value , 0 ),info:'The number of customers who have purchased items at their regular, listed price without any discounts or promotions'},
            {id:2,title:"Top Deal Customers",value:data?.v3.topDealCustomers.reduce((a,v) =>  a = a + v.value , 0 ),info:"The number of customers who have purchased items offered under a 'Top Deal' promotion or discount"},
            {id:3,title:"Exclusive Customers",value:data?.v3.exclusiveCustomers.reduce((a,v) =>  a = a + v.value , 0 ),info:'The number of customers who have purchased items that are only available at The Cricket Store'},
        ]
        // const d3=[{
        //     name:'Returning Customers',
        //     data: [44, 55, 41, 67, 22, 43]
        //   },
        //   {
        //     name:'New Customers',
        //     data: [13, 23, 20, 8, 13, 27]
        //   }]

          const d3= [
            {
              name: "New Customers",
              data:  getChartDataByMonth(data?.v2),
              x: getMonthofYear()
            },
            {
                name: "Returning Customers",
                data:  getChartDataByMonth(data?.v1),
                x: getMonthofYear()
              }
          ]
        
        const d4=[
            {
            name:'Standard Price',
            data: getChartDataByMonth(data?.v3.standardCustomers),
            x:getMonthofYear()
            },
            {
            name:'Top Deal',
            data: getChartDataByMonth(data?.v3.topDealCustomers),
            x:getMonthofYear()
            },
            {
                name:'Exclusive',
                data: getChartDataByMonth(data?.v3.exclusiveCustomers),
                x:getMonthofYear()
            }
        ]
        let info='This is the content about customer metrics'
        function box(title,value,info){
            return (
                <Paper className="padding2" style={{marginBottom:'1px'}}>
                    <h6 className="ruby" >{title}   {info!=null &&<FaInfoCircle size="20px"color="red" className="click space-left2" onClick={(e) => openPopup('info', e,info)} />}</h6>
                    <div>{value}</div>
                </Paper>
            )
        }

        return (
            <div className="tabPanelCls h-100" >
                <div className="dispatchTimer" style={{ position: 'relative' }}>
                    <div className="fixed">
                        <div style={{ paddingTop: "5px" }}>
                            <h2 className="ruby center"><IconButton onClick={()=>setPage(1)}><FaBackspace/></IconButton>Customer Metrics<FaInfoCircle size="20px"color="red" className="click space-left2" onClick={(e) => openPopup('info', e,info)} /></h2>
                        </div>
                    </div>

                    <div style={{marginTop:isTabletOrMobile?"50px":"80px"}}>
                    {filter("Select date range ")}
                        <Grid container spacing={2}>
                            <Grid item md={12}>
                                <Grid container spacing={2}>
                                {d1.map((d)=>{
                                    return (
                                        <Grid item md={3}>
                                            {box(d.title,d.value,d.info)}
                                        </Grid>
                                    )
                                })}
                                </Grid> 
                                {barChart(d3,'Unique Customers',2,isTabletOrMobile?230:400)}
                            </Grid>
                            <Grid item md={12}>
                                <Grid className="space-bottom" container spacing={2} style={{overflowX: isTabletOrMobile &&'auto'}}>
                                {d2.map((d)=>{
                                    return (
                                        <Grid item md={3} xs={12}>
                                            {box(d.title,d.value,d.info)}
                                        </Grid>
                                    )
                                })}
                                </Grid>
                               
                            </Grid>

                            <Grid item md={12} xs={12}>
                                <div >
                                {lineChart(d4,"Orders","straight",2)}
                                </div>
                            </Grid>

                            
                        </Grid>
                    </div>
                </div>
            </div>
        )
    }

    function getMetrics() {
        return (
            <div className={!isTabletOrMobile &&"fixed3"} style={{ width: '200px', right: '20px',top:'200px' }}>
                <div className="bold space-top space-bottom2">Operational Metrics</div>
                <Stack direction={"column"} spacing={1}>
                    <Button variant="contained" onClick={()=>{setPage(2);closePopup()}} endIcon={<FaArrowRight sx={{ color: 'red' }} />}>Acceptance Time</Button>
                    <Button variant="contained" onClick={()=>{setPage(3);closePopup()}} endIcon={<FaArrowRight sx={{ color: 'red' }} />}>Lost Revenue</Button>
                    <Button variant="contained" onClick={()=>{setPage(4);closePopup()}}  endIcon={<FaArrowRight sx={{ color: 'red' }} />}>AVG Dispatch Time</Button>
                    {localStorage.getItem("roleId") === "1" &&(<Button variant="contained" onClick={()=>{setPage(8);closePopup()}}  endIcon={<FaArrowRight sx={{ color: 'red' }} />}>AVG Delivery Time</Button>)}
                </Stack>
                <div className="bold space-top space-bottom2">Customer Insights</div>
                <Stack direction={"column"} spacing={1}>
                    <Button variant="contained" onClick={()=>{setPage(5);closePopup()}} endIcon={<FaArrowRight sx={{ color: 'red' }} />}>Top Selling Items</Button>
                    <Button variant="contained" onClick={()=>{setPage(6);closePopup()}} endIcon={<FaArrowRight sx={{ color: 'red' }} />}>Feedback</Button>
                    <Button variant="contained" onClick={()=>{setPage(7);closePopup()}} endIcon={<FaArrowRight sx={{ color: 'red' }} />}>Customer Metrics</Button>
                </Stack>
            </div>
        )
    }

    function filter(title,action='Filter') {
        const timeBase=[
            {id:0,name:'All Time'},
            {id:1,name:'Out of Hours - 6pm-8am'},
            {id:2,name:'Morning - 8am - 12pm'},
            {id:3,name:'Afternoon - 12pm - 6pm'},
        ]

        const handleChanged = (event) => {
            setAllMerchant(event.target.checked);
          };
        function otherFilter(){
            return (
                <Stack direction={"column"} spacing={1} className="center">
                     {isAdmin &&
                    <Stack direction={'row'} className="center">
                    <Switch
                        checked={allMerchant}
                        label
                        size="small"
                        onChange={handleChanged}
                        inputProps={{ 'aria-label': 'controlled' }}
                        />
                        <span className="xs truncate bold red">All Merchant</span>
                        </Stack>
                    }
                    <Stack direction={"row"} className="center click" onClick={(e)=>openPopup(action,e)}>
                        {/* <IconButton size="small"> <FaSort style={{color:'red'}} /></IconButton>
                        <RxDividerVertical fontSize={'20px'}/> */}
                        <IconButton size="small" > <FaFilter size={"10px"} style={{color:'red'}} /></IconButton>
                        <span className="xs truncate bold red">{action=='Filter'?currentCategory?.label:currentTime?.name}</span>
                        <Spinner
                            size={20}
                            color="red"
                            loading={isLoading}
                            // style={{ marginTop: marginTop }}
                        />
                    </Stack>
                   
                </Stack>
            )
        }
        return (
            <div>
                <Grid container spacing={0} className=" space-bottom" alignContent={"space-evenly"} >
                    <Grid item md={10} xs={12}>
                        <Stack direction={"row"} spacing={1} className="center2">
                            
                            <Grid container spacing={isTabletOrMobile?1:5}>
                            <Grid item md={'auto'} xs={12} className={[" mpx",!isTabletOrMobile &&" center"].join(' ')}>
                                <div  className={["push-left-right ","space-bottom2"].join(' ')}>
                                 <span style={{marginTop:isTabletOrMobile &&'30px'}} className={["sm space-right ",!isTabletOrMobile ?'center':'padding-top1'].join(' ')}>{title}</span>
                                 {isTabletOrMobile && otherFilter()}
                                </div>
                            </Grid>
                            <Grid item md={'auto'} xs className="mpx">
                                <DatePicker
                                    placeholderText="Select date"
                                    className="datepicker click"
                                    onChange={(date) => {
                                        updateState({ startDate: date })
                                    }}
                                    selectsStart
                                    showMonthDropdown
                                    showYearDropdown
                                    value={startDate != null && moment(startDate).format('DD/MM/yyyy')}
                                    dropdownMode="select"
                                    dateFormat="dd/MM/yyyy"
                                    selected={startDate}
                                    startDate={startDate}
                                    disabledKeyboardNavigation={false}
                                    onFocus={e => e.target.blur()} 
                                    onBeforeInput={(e) => {
                                        e.preventDefault();
                                    }}
                                    endDate={endDate}
                                    maxDate={endDate}
                                />
                            </Grid>
                            <Grid item md={'auto'} xs={1}  className="center mpx">
                            <span className={["sm ",!isTabletOrMobile &&"padding-x"].join(' ')}>to</span>
                            </Grid>
                            <Grid item md={'auto'} xs className="mpx" >
                                <DatePicker
                                    placeholderText="Select date"
                                    className="datepicker click"
                                    onChange={(date) => {
                                        updateState({ endDate: date })
                                    }}
                                    selectsStart
                                    showMonthDropdown
                                    showYearDropdown
                                    value={endDate != null && moment(endDate).format('DD/MM/yyyy')}
                                    dropdownMode="select"
                                    dateFormat="dd/MM/yyyy"
                                    selected={endDate}
                                    startDate={startDate}
                                    endDate={endDate}
                                    minDate={startDate}
                                    disabledKeyboardNavigation={false}
                                    onFocus={e => e.target.blur()} 
                                    onBeforeInput={(e) => {
                                        e.preventDefault();
                                    }}
                                />
                            </Grid>
                        </Grid>

                        </Stack>
                        
                    </Grid>
                   {!isTabletOrMobile && <Grid item md={2} xs={4}>
                       { otherFilter()}
                    </Grid>}
                </Grid>
                <Popup close={closePopup}   target={popup["Filter"]} >
                    <div style={{maxHeight:isTabletOrMobile?'600px':'400px',overflowY:'scroll'}}>
                    <div onClick={()=>{setSelectedCategory(null);closePopup()}} >
                        <div style={{padding:isTabletOrMobile?'12px 20px':'8px 20px'}} className="click text hover" >
                            <span className="sm">All Products </span>
                        </div>
                            <Divider/>
                        </div>
                    {prodCategories?.map((d,i)=>{
                    return (
                        <div onClick={()=>{setSelectedCategory(d);closePopup()}} >
                        <div style={{padding:isTabletOrMobile?'12px 20px':'8px 20px'}} className="click text hover" >
                            <span className="sm">{d.label} </span>
                        </div>
                            <Divider/>
                        </div>
                    )
                    })}
                    </div>
                </Popup>
                <Popup close={closePopup} target={popup["Filter2"]} >
                    <div style={{maxHeight:'300px',overflowY:'auto'}}>
                    {timeBase?.map((d,i)=>{
                    return (
                        <div key={i} onClick={()=>{setCurrentTime(d); closePopup()}} >
                        <div style={{padding:'5px 15px'}} className="click text hover" >
                            <span className="sm">{d.name} </span>
                        </div>
                            <Divider/>
                        </div>
                    )
                    })}
                    </div>
                </Popup>
                <Popup close={closePopup}  target={popup.info} >
                    <div className="center padding2 white" style={{ maxHeight: '300px', width: '300px', overflowY: 'auto', background: '#DE031E', borderRadius: '10px 10px 0px 0px' }}>
                        <FaInfoCircle size={25} color="white" className="center3" style={{ width: '100%' }} />
                        <div className="lg bold">Information</div>
                        <div className="sm">{popup.content}</div>
                    </div>
                    <Button onClick={() => closePopup()}
                        variant="contained" fullWidth sx={{ background: "white", color: "#DE031E" }}>Ok</Button>
                </Popup>

                <Popup close={closePopup}  target={popup.more} >
                    <div className="padding">
                        {getMetrics()}
                    </div>
                </Popup>
            </div>
        )
    }

    function extractedValue (arr,prop,type){
      return  arr?.map(function(item) {
        if(type!=null) return moment.monthsShort(item[prop] - 1)
        return item[prop]
    })
    } 

    function getChartDataByMonth(arr){
        var keys = [];
        if(arr!=null){
            [1,2,3,4,5,6,7,8,9,10,11,12].map(d=>{
                var s=arr.filter(x=>x.month==d)[0]
                s==null?keys.push(0) : keys.push( Math.round(s.value * 100) / 100)
            })
        }
       
        return keys
    }

    function getChartDataByProductCat(arr){
        var keys = [];
        // if(arr!=null){
        //     productCategories.map(d=>{
        //         let s=arr.filter(x=>x.productCat==d.name)[0]
        //         s==null?keys.push(0) : keys.push((s.value))
        //     })
        // }
        if(arr!=null){
            productCategories.map(d=>{
                let s=arr.filter(x=>x.productCat==d.name)[0]
                s?.value>0 && keys.push((s.value))
            })
        }
        return keys
    }

   

    function getMonthofYear(){
        return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"]
    }

    function getOrders() {
        const data=summaryData?.data?.orders
        const d1= data?.top.filter(x=>x.type==2)
        const d2= data?.top.filter(x=>x.type==1)
      //  const d3=summaryData?.data.chart

        // const d1= [
        //     {id:1,title:"Total completed orders",value:(45323)},
        //     {id:2,title:"Total unique customers",value:(323)},
        //     {id:3,title:"AVG items per basket ",value:(533)},
        //     {id:4,title:"% orders returned",value:(35+'%')},
        // ]
        // const d2=[
        //     {id:1,name:"New Orders",value:16},
        //     {id:2,name:"In Progress",value:16},
        //     {id:3,name:"Ready for Shipment",value:12},
        //     {id:4,name:"Out for delivery",value:4},
        // ]
        function box(title,value){
            return (
                <Paper className="padding">
                    <h6 style={{color:'#AEAEAE'}} className="truncate">{title}</h6>
                    <div>{value}</div>
                </Paper>
            )
        }
        
     
        const d3= [
            {
              name: "This Year",
              data:  getChartDataByMonth(data?.chart.thisyear),
              x: getMonthofYear()
            },
            {
              name: "Last Year",
              data: getChartDataByMonth(data?.chart.lastyear),
              x:getMonthofYear()
            }
          ]
        const d4= [
            {
              name: "This Year",
              data:  getChartDataByMonth(data?.chart.thisyear2),
              x: getMonthofYear()
            },
            {
              name: "Last Year",
              data: getChartDataByMonth(data?.chart.lastyear2),
              x:getMonthofYear()
            }
          ]
        return (
            <Grid container>
                <Grid item md={10} xs={12}>
                <div style={{width:'100%'}}>
                    {filter("Orders overview for ")}
                </div>
                <Grid container spacing={2} alignContent={"space-evenly"}>
                    <Grid item md={6} xs={12}>
                        <Grid container spacing={2}>
                            {d1?.map((d,i)=>{
                                return (
                                    <Grid key={d.key} item md={6} xs={6}>
                                        {box(d.key,d.value)}
                                    </Grid> 
                                )
                            })}
                        </Grid>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <Grid container spacing={2} className={isTabletOrMobile&&"center"}>
                            <Grid item md={12} xs={7}>
                                {d2!=null &&pieChart(d2?.map(a => a.key),d2?.map(a => a.value),isTabletOrMobile)}
                            </Grid>
                        {isTabletOrMobile && <Grid item xs={5}>
                                {d2?.map((d,i)=>{
                                    return (
                                        <Paper key={d.key} className=" push-left-right space-bottom2" style={{background:"#F0F0F0 0% 0% no-repeat padding-box",padding:'3px 7px'}}>
                                            <div style={{color:'#AEAEAE',fontSize:'11px'}}>{d.key}</div>
                                            <div style={{color:'#AEAEAE'}} className="bold sm">{d.value}</div>
                                        </Paper>
                                    )
                                })}
                            </Grid> 
                        }
                        </Grid>
                    </Grid>
                </Grid>

                <div>
                    <div className="space-top bold">Total Orders</div>
                    <div>
                    {lineChart(d3,"Total Orders","straight")}
                    </div>
                </div>

                <div>
                    <div className="space-top bold">Total Items Sold</div>
                    <div>
                    {lineChart(d4,"Total Items Sold","straight")}
                    </div>

                </div>
                </Grid>
            </Grid>
        )
    }

    function getRevenue() {
        const data=summaryData?.data?.revenue
        const d3= [
            {
              name: "Revenue",
              data:  getChartDataByMonth(data?.v1),
              x: getMonthofYear()
            }
          ]
        const d4= [
            {
              name: "Revenue",
              data:  getChartDataByProductCat(data?.v2),
              x: productCategories.filter(d=>
                data?.v2?.filter(x=>x.productCat==d.name)[0]?.value>0
            ).map((m) => ( m.name))
            }
          ]
        return (
            <Grid container>
                <Grid item md={10} xs={12}>
                <div style={{width:'100%'}}>
                    {filter("Revenue overview for ")}
                </div>
                <div>
                {barChart(d3,"Revenue (£)",1,isTabletOrMobile?230:400)}
                <h3 className="space-top">Revenue by Product Type</h3>
                {barChart(d4,"Revenue (£)",1,isTabletOrMobile?230:400)}
                </div>
                <div className="space-bottom">
                        <Grid container spacing={2}>
                            {data?.v3?.map((d,i)=>{
                                const progress=d.value==0?0:(d.value/ data.v3.reduce((a,v) =>  a = a + v.value , 0 ))
                                return (
                                    <Grid key={d.key} item md={4} xs={i==0?12:12}>
                                        <Paper className="padding">
                                        <div className="bold">{d.key}</div>
                                        <Progress value={progress}/>
                                        <div className="center grey xs">Revenue</div>
                                        </Paper>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </div>
                </Grid>
            </Grid>
        )
    }

    function getAVGBasket() {
                
        const data=summaryData?.data?.basket
      
        const d3= [
            {
              name: "Average Basket Ordered",
              data:  getChartDataByMonth(data?.v1),
              x: getMonthofYear()
             }
          ]
        return (
            <div>
                 <Grid container>
                    <Grid item md={10} xs={12}>
                    <div style={{width:'100%'}}>
                     {filter("AVG basket overview for ")}
                    </div>
                
                    <div>
                        {lineChart(d3,"Orders","straight")}
                    </div>
                    <div className="space-bottom">
                        {data?.v3?.p1!=null 
                        &&<Grid container spacing={2}>
                            {/* <Grid item md={4}>
                                <div className="bold ruby center">Basket Checkout Percentage<FaInfoCircle size="15px"color="red" className="click space-left2" onClick={(e) => openPopup('info', e,'% checkout from viewing product page to purchase')} /></div>
                                <Progress value={0.3}/>
                                <div className="center grey xs">Percentage Complete</div>

                            </Grid> */}
                            {/* <Grid item md={4}>
                                <div className="bold ruby center">Average Number of Basket Items<FaInfoCircle size="15px"color="red" className="click space-left2" onClick={(e) => openPopup('info', e,'number of items for that brand in every basket which included an item from this brand')} /></div>
                                <Progress value={0.5}/>
                                <div className="center grey xs">Number of Items</div>
                            </Grid> */}
                            <Grid item md={4} xs={12}>
                            <Paper className="padding">
                                <div className="bold ruby center sm">% of Basket Spend per Customer <FaInfoCircle size="15px"color="red" className="click space-left2" onClick={(e) => openPopup('info', e,"The percentage of a customer's total basket value that comes from items purchased from your brand.")} /> </div>
                                <Progress value={data?.v3?.p1}/>
                                <div className="center grey xs">Percentage</div>
                            </Paper>
                            </Grid>
                            <Grid item md={4} xs={12}>
                            <Paper className="padding">
                                <div className="bold ruby center sm">AVG Number of Items per Basket <FaInfoCircle size="15px"color="red" className="click space-left2" onClick={(e) => openPopup('info', e,"The average number of items from your brand that the customer purchases within their order")} /> </div>
                                <h3 className="center2">{data?.v3?.p2}</h3>
                                <div className="center grey xs">Number of Items</div>
                            </Paper>
                                
                            </Grid>
                            <Grid item md={4} xs={12}>
                            <Paper className="padding">
                                <div className="bold ruby center sm">Conversion Rate % <FaInfoCircle size="15px"color="red" className="click space-left2" onClick={(e) => openPopup('info', e,"The percentage of visitors to a product page who end up making a purchase")} /> </div>
                                <Progress value={data?.v3?.p3}/>
                                <div className="center grey xs">Percentage Complete</div>
                                </Paper>
                            </Grid>
                        </Grid>
                        }
                    </div>
                    </Grid>
                </Grid>
            </div>
        )
    }


    function countdown(s) {
        s=s*60;

        const d = Math.floor(s / (3600 * 24));
      
        s  -= d * 3600 * 24;
      
        const h = Math.floor(s / 3600);
      
        s  -= h * 3600;
      
        const m = Math.floor(s / 60);
      
        s  -= m * 60;
      
        const tmp = [];
      
        (d) && tmp.push(d + (d>1?'days':'day'));
      
        (d || h) && tmp.push(h + (h>1?'hrs':'hr'));
      
        (d || h || m) && tmp.push(m + (m>1?'mins':'min'));
      
        // tmp.push(s + 's');
      
        return tmp.join(' ');
      }

}

export default Summary;
